import { DrawerProps, TableProps } from 'antd';
export interface IDeploymentProps {
  loading?: boolean;
  deploySuccess?: boolean;
  drawerProps?: DrawerProps;
  onDeploy?: (value: any) => void;
  metricType?: string;
  enableSecondPanel?: boolean;
}

export interface IDeploymentTable {
  loading?: boolean;
  tableProps?: TableProps<any>;
}

export enum WorkbenchAction {
  deployWorkBench = 'Deploy to Trends (Workbench)',
  exportToProduction = 'Export to Production Activation',
}
